import { render, staticRenderFns } from "./AddStudent.vue?vue&type=template&id=828f6804&scoped=true"
import script from "./AddStudent.vue?vue&type=script&lang=js"
export * from "./AddStudent.vue?vue&type=script&lang=js"
import style0 from "./AddStudent.vue?vue&type=style&index=0&id=828f6804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828f6804",
  null
  
)

export default component.exports